export default async function csrfPost (path: string, data: object, retry = true) {
  const tokenElement = document.querySelector('meta[name="csrf-token"]')
  const token = tokenElement.getAttribute('content')
  const response = await fetch(path, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': token
    },
    credentials: 'same-origin',
    body: JSON.stringify(data)
  })

  const json = await response.json()
  if (response.status === 403 && json.error === 'Invalid authentication token' && retry) {
    const newToken = await fetchToken()
    if (newToken) {
      tokenElement.setAttribute('content', newToken)
    }

    return await csrfPost(path, data, false)
  }

  return json
}

async function fetchToken () {
  const response = await fetch('/new_csrf', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })

  if (!response.ok) return

  const json = await response.json()
  return json.csrf_token
}
